import { BsModalService } from 'ngx-bootstrap/modal'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'

import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'

import { ConfigurationOption } from '../configuration-option'
import { configurationOptionActions } from '../configuration-option.actions'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { AccessRights } from '../../role/user-role/user-role'

@Component({
  selector: 'configurationOptions-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class ConfigurationOptionIndexComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public configurationOptions$: Observable<ConfigurationOption[]>
  public accessRights = AccessRights

  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit() {
    this.store.dispatch(configurationOptionActions.initActions())

    this.configurationOptions$ = this.store.select(
      configurationOptionSelectors.selectAll
    )

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
  }

  public onClickRow(configurationOption: ConfigurationOption) {
    this.router.navigate(['/configuration-options', configurationOption.id])
  }

  public onClickCreate() {
    this.router.navigate(['/configuration-options/create'])
  }

  public onBulkAction(bulkActionEvent: BulkActionEvent) {
    if (bulkActionEvent.action == BulkAction.DELETE) {
      bulkActionEvent.items.forEach((i) =>
        this.store.dispatch(configurationOptionActions.deleteOne({ id: i.id }))
      )
    }
  }
}
